// Typelizer digest dc04559974f0d87659ca569a152a30c6
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/teams/:team_id/team_applications */
  index: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/team_applications', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/teams/:team_id/team_applications/:id */
  update: (
    params: { teacherId: string | number; teamId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/team_applications/:id', params, options),
    method: 'patch',
  }),
}
